import { parseApiError } from "@rawa/api-client/ApiResponseError"
import { AuthSessionSchema, type AuthSession } from "shared"

export async function fetchAuthSession(): Promise<void> {
  const res = await fetch("/api/auth/session")
  if (!res.ok) throw await parseApiError(res)
}

/**
 * The same session probe, read for who holds it rather than whether anyone does.
 *
 * Separate from `fetchAuthSession` because the guards only need the answer to
 * the second question, and a parse failure must not be able to turn a valid
 * session into a redirect to sign-in.
 */
export async function fetchAuthSessionUser(): Promise<AuthSession> {
  const res = await fetch("/api/auth/session")
  if (!res.ok) throw await parseApiError(res)
  return AuthSessionSchema.parse(await res.json())
}

export async function postLogout(): Promise<void> {
  await fetch("/api/auth/logout", { method: "POST" })
}
